import TomSelect from 'tom-select';

export default class SchoolSearchField {
  constructor(selectElement, schoolsData = [], selectedValue) {
    this.selectElement = selectElement;
    this.schoolsData = schoolsData;
    this.placeholder = this.selectElement?.placeholder || 'School Name';
    this.selectedValue = selectedValue;
  }

  connect() {
    this.tomSelect = new TomSelect(this.selectElement, {
      hideSelected: true,
      persist: false,
      valueField: 'id',
      labelField: 'name',
      searchField: 'name',
      options: this.schoolsData,
      placeholder: this.placeholder,
      onItemAdd: function() {
        this.blur();
      }
    });

    if (this.selectedValue) {
      this.tomSelect.setValue(this.selectedValue);
    }
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
